export default __webpack_public_path__ + "static/media/winsportbet_white.ba054116.svg";